// extracted by mini-css-extract-plugin
export default {"blogPost":"blogpost_blogPost__ORSTX"};